import { render, staticRenderFns } from "./programa-integrado-con-listado.vue?vue&type=template&id=3079d637&"
import script from "./programa-integrado-con-listado.component.ts?vue&type=script&lang=ts&"
export * from "./programa-integrado-con-listado.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports